import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-57da45ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: _imports_0
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-moon icon-list" }, null, -1))
const _hoisted_5 = { class: "sub-menu mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-moon icon-list2" }, null, -1))
const _hoisted_7 = { class: "sub-menu mt-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-moon icon-list2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-moon icon-users" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-moon icon-list2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-moon icon-list2" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-menu mt-3" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-moon icon-list2" }, null, -1))
const _hoisted_14 = { class: "sub-menu mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", [{ minimized: _ctx.hideMenu }, { min: _ctx.min }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goHome()))
      }, _hoisted_3),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args))),
        class: "log-text"
      }, "LOGGER")
    ]),
    _createElementVNode("nav", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item sub", {
          'active-sub-menu': _ctx.activeMenu == 1,
        }])
      }, [
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActivMenu(1)))
        }, [
          _hoisted_4,
          _createTextVNode("Логи методов ")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'metod-list' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Список методов ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'average-response-time-of-methods' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Среднее время откл. методов ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'number-of-open-and-closed-sessions' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Кол-во откр. и закр. сессий ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'number-active-users' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Кол-во активных пользователей ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'logs-view' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Просмотр логов ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'active-logs-view' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Активные методы ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'top-height-methods-load' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Топ нагруженных методов ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'logs-statistics' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Статистика ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'logs-view-errors' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Ошибки ")
            ]),
            _: 1
          })
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([{
          'active-sub-menu': _ctx.activeMenu == 2,
        }, "menu-item sub"])
      }, [
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setActivMenu(2)))
        }, [
          _hoisted_6,
          _createTextVNode(" Логи контента ")
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'content-logs-view' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Просмотр логов ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'content-logs-view-active' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Активные логи ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'content-logs-view-errors' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Ошибки ")
            ]),
            _: 1
          })
        ])
      ], 2),
      _createVNode(_component_router_link, {
        class: "menu-item",
        "exact-active-class": 'active',
        to: { name: 'projects' }
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _createTextVNode(" Проекты ")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "menu-item",
        "exact-active-class": 'active',
        to: { name: 'user-list' }
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _createTextVNode("Список пользователей ")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "menu-item",
        "exact-active-class": 'active',
        to: { name: 'text-logs-view' }
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _createTextVNode("Текстовые логи ")
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass([{
          'active-sub-menu': _ctx.activeMenu == 3,
        }, "menu-item sub"])
      }, [
        _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setActivMenu(3)))
        }, [
          _hoisted_11,
          _createTextVNode(" Логи Http")
        ]),
        _hoisted_12,
        _createVNode(_component_router_link, {
          class: "menu-item",
          "exact-active-class": 'active',
          to: { name: 'http-logs-view' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Просмотр логов ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "menu-item",
          "exact-active-class": 'active',
          to: { name: 'http-top-height-methods-load' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Топ нагруженных методов ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "menu-item",
          "exact-active-class": 'active',
          to: { name: 'http-active-logs-view' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Активные логи ")
          ]),
          _: 1
        })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([{
          'active-sub-menu': _ctx.activeMenu == 4,
        }, "menu-item sub"])
      }, [
        _createElementVNode("div", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setActivMenu(4)))
        }, [
          _hoisted_13,
          _createTextVNode(" Логи Ws")
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'ws-logs-view' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Просмотр логов ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "menu-item",
            "exact-active-class": 'active',
            to: { name: 'ws-active-logs-view' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Активные логи ")
            ]),
            _: 1
          })
        ])
      ], 2)
    ])
  ], 2))
}